import classNames from 'classnames';
import React from 'react';

import { Loader } from '../../common/loader/loader';

import styles from './loading-spinner-for-modal.scss';

interface Props {
  layerClassName?: string;
}

export const LoadingSpinnerForModal = ({ layerClassName }: Props) => (
  <div className={classNames(styles.spinnerLayer, layerClassName)}>
    <Loader size="medium" />
  </div>
);
